import request from '@/utils/request'

// 조회
export function getEducationProcedure(params, isProgress) {
  return request({
    url: `/api/getEducationProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}
// 예시
export function getEducationProcedureSample(isProgress) {
  return request({
    url: `/api/getEducationProcedureSample`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isProgress, apitype: 'searched' }
  })
}
// 저장
export function saveEducationProcedure(params, isProgress) {
  return request({
    url: `/api/saveEducationProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' }
  })
}
// 삭제
export function deleteEducationProcedure(params, isProgress) {
  return request({
    url: `/api/deleteEducationProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'deleted' }
  })
}
// 출력
export function getEducationProcedureReport (params, isProgress) {
  let responseType = "blob"
  return request({
    url: '/api/getEducationProcedureReport',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    responseType: responseType,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}